/**
 * Shared, cross-feature constants.
 * Keep each value immutable at the module boundary (use Object.freeze for grouped values).
 */

/**
 * Upper bound for the top-bar facility dropdown fetch. The backend applies pagination
 * only when both page + itemsPerPage are supplied, so a large ItemsPerPage effectively
 * fetches "all accessible facilities" without a dedicated endpoint. If any user ever
 * exceeds this, we switch to the server-side typehead endpoint.
 */
export const FACILITY_DROPDOWN_LIMIT = 1000;

/**
 * TTL for the cached accessible-facilities list in milliseconds (5 minutes).
 * Prevents re-fetching on every dropdown open while keeping the list fresh enough
 * that a new facility granted mid-session appears after at most 5 min.
 */
export const FACILITY_DROPDOWN_CACHE_MS = 5 * 60 * 1000;
